import { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Button } from "@primer/react";
import { ArrowDownIcon } from "@primer/octicons-react";

import FilterContainer from "../FilterContainer";
import Navbar from "../Navbar";
import useMediaQuery from "../../customHooks";

import allPosts from "../../posts.json";
import styles from "./index.module.css";
import Post from "../Post";
import PostDetail from "../PostDetail";
import { ALL_POSTS_LABEL } from "../../constants";

const PAGE_LIMIT = 10;

const Home = () => {
  const [currentOffset, setCurrentOffset] = useState(0);
  const [selectedLabels, setSelectedLabels] = useState([ALL_POSTS_LABEL]);
  const [searchText, setSearchText] = useState("");

  const [searchParams] = useSearchParams();
  const params = useParams();

  const isMobile = useMediaQuery("(max-width: 1020px)");

  const isIframeUrl = searchParams.get("iframe") === "true";

  const slug = params.slug;
  const isSlugPage = !!slug;

  let filteredPosts = [...allPosts];

  const labelFilterArray = selectedLabels.filter(
    (label) => label !== ALL_POSTS_LABEL
  );

  // Filter posts based on labels present in url
  if (labelFilterArray && labelFilterArray.length > 0) {
    filteredPosts = allPosts.filter((post) => {
      const postLabel = post.labels || [];

      return postLabel.some((label) => {
        return labelFilterArray.includes(label.trim());
      });
    });
  }

  // filter posts on basis of search query
  if (searchText) {
    filteredPosts = filteredPosts.filter((post) => {
      const postTitle = post.title || "";
      const postBody = post.body || "";
      const postLabel = post.labels || [];
      return (
        postTitle.toLowerCase().includes(searchText.toLowerCase()) ||
        postBody.toLowerCase().includes(searchText.toLowerCase()) ||
        postLabel.some((label) =>
          label.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    });
  }

  const totalPostCount = filteredPosts.length;
  const totalPages = Math.ceil(totalPostCount / PAGE_LIMIT);
  const currentPage = Math.floor(currentOffset / PAGE_LIMIT) + 1;

  const postsToShow = filteredPosts.slice(0, currentOffset + PAGE_LIMIT);
  const showMoreButton = currentPage < totalPages;

  return (
    <div
      className={`${styles.container} ${
        isIframeUrl ? `${styles.iframeContainer}` : {}
      }`}
    >
      {!isIframeUrl && <Navbar />}
      <div
        className={`${styles.home} ${
          isIframeUrl ? `${styles.iframeHome}` : {}
        }`}
      >
        <div
          className={`${styles.posts} ${
            isIframeUrl ? `${styles.iframePosts}` : {}
          }`}
        >
          {isSlugPage ? (
            <PostDetail />
          ) : (
            <>
              {postsToShow.length > 0 ? (
                postsToShow.map((post, index) => {
                  return (
                    <>
                      <Post key={`${post?.title}-${index}`} post={post} />
                    </>
                  );
                })
              ) : (
                <div>
                  <h2>No Posts Found</h2>
                  <p>Try changing the filters</p>
                </div>
              )}
            </>
          )}

          {!isSlugPage && showMoreButton && (
            <Button
              variant="default"
              trailingVisual={ArrowDownIcon}
              size="large"
              onClick={() => {
                setCurrentOffset((prevOffset) => prevOffset + PAGE_LIMIT);
              }}
              className={styles.showMore}
            >
              Show Previous Entries
            </Button>
          )}
        </div>{" "}
        {!isIframeUrl && !isMobile && (
          <FilterContainer
            selectedLabels={selectedLabels}
            setSelectedLabels={setSelectedLabels}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        )}
      </div>
    </div>
  );
};

export default Home;
